/**
Abstract Class for States
**/
import _ from 'lodash';
import { action, makeObservable, observable } from 'mobx';

class AbstractStore {
  pending = false;
  loaded = false;
  data = new Map();

  MESSAGE = 'Loading';

  constructor() {
    makeObservable(this, {
      pending: observable,
      loaded: observable,
      data: observable,
      setCacheData: action,
    });
  }

  setCacheData = (data) => {
    _.forEach(data, (val, key) => {
      this.data.set(key, val);
    });

    this.pending = false;
    this.loaded = true;
  };

  reset = () => {
    this.pending = false;
    this.loaded = false;
    this.data.clear();
  };
}

export default AbstractStore;
